import { Component, ViewChild } from '@angular/core';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { billData } from './utilities-data';
import { invoiceData } from './invoice-data';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver';

import * as XLSX from 'xlsx';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';
import {
  orderBy,
  SortDescriptor,
  filterBy,
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';

import { Router } from '@angular/router';
import { Store, compose, select } from '@ngrx/store';
import { LoaderService } from '../../../core/services/loader.service';
import {
  getBillsByIdResponse,
  getresidentialResponse,
} from '../../../store/Bills/bills-selector';
import { take } from 'rxjs';
import {
  createBillChargeResponse,
  deleteBillChargeResponse,
  getAllBillSettingResponse,
  getBillSettingResponse,
  getBillinvloiceResponse,
  getOptionalResponse,
  updateBillChargeResponse,
  updateOptionalBillChargeResponse,
} from '../../../store/billsSettings/billSettings-selector';
import {
  createBillCharge,
  createInvoice,
  createOptionalBillCharge,
  deleteBillCharge,
  deleteInvoice,
  getAllBillSettingslists,
  getBillSettingslists,
  getBillinvloicelist1,
  getOptionallist,
  resetState,
  updateBillCharge,
  updateInvoice,
  updateOptionalBillCharge,
} from '../../../store/billsSettings/billSettings.action';
import { SharedService } from '../../../shared/shared.service';
import { Validations } from '../../../shared/constants/validations';
import { projectBillingDates } from '../../../shared/constants/projectBillingDates';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { process, State } from '@progress/kendo-data-query';
import { PdfexportService } from '../../../core/services/pdfexport.service';
import { table_pageSize } from '../../../shared/constants/templatesNames';

import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { SweetAlertIcon } from '../../../shared/constants/enum';
import { Helper } from '../../../core/helpers/helper';
import { formatDate } from '@angular/common';
import _ from 'lodash';

import { ReportsService } from '../../../core/services/reports.service';
import { BillSettingsService } from '../../../core/services/bill-settings.service';
import { NotificationService } from '../../../shared/notification.service';
@Component({
  selector: 'app-bill-settings',
  templateUrl: './bill-settings.component.html',
  styleUrl: './bill-settings.component.scss',
  standalone: false,
})
export class BillSettingsComponent {
  selectValue!: string[];
  projectBillingDates = projectBillingDates;
  // billsChargeForm!: UntypedFormGroup;
  form!: UntypedFormGroup;
  myRestrictions: FileRestrictions = {
    allowedExtensions: ['.jpg', '.png'],
  };
  currentdate: any;
  breadCrumbItems: Array<{}> | undefined;
  // invoiceAddForm!: UntypedFormGroup;
  individualbillForm!: UntypedFormGroup;
  UtlityindividualbillForm!: UntypedFormGroup;
  combinedBillForm!: UntypedFormGroup;
  public selectableSettings!: SelectableSettings;
  public checkboxOnly = true;
  public drag = false;
  public mode: SelectableMode = 'multiple';
  orderByQuery: string = '';
  queryString: string = '';
  uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
  uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
  public billSettinggridData: GridDataResult = { data: [], total: 0 };
  billSettingList: any[] = [];
  billselectedRowdata: any = [];
  billsdeselectedRowdata: any = [];
  optionalList: any = ([] = []);
  isPenalityApplicable: any = false;
  invoicesearchedValue = '';
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  public billsSettings: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  /*   public billsInvoice: State = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    }; */

  public billInvoicegridData: GridDataResult = { data: [], total: 0 };
  billInvoiceList: any[] = [];
  billsInvoicetotalUserCount: number = 0;

  public pageSize = 10;
  public skip = 0;
  billstotalUserCount: number = 0;
  prifileValidations = Validations;

  modelRef_1!: BsModalRef;
  invoiceAdd!: BsModalRef;

  isAllOpen: boolean = true;
  public filterMode: FilterableSettings = 'row';
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  url: any = '';
  hidden!: boolean;
  public sort: SortDescriptor[] = [];
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };

  modalRef!: BsModalRef;
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };
  //ublic billpageSizes = true;
  public pageSizes = table_pageSize.pageSizes;
  public previousNext = true;

  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';

  submitted: boolean = false;
  optionalSubmitted: boolean = false;
  individualbillSubmitted: boolean = false;
  searchedValue: any = '';
  configData: any;
  utilityList: any[] = [];
  // filtered list used in dropdowns to exclude certain utilities (e.g., EV)
  filteredUtilityList: any[] = [];
  selectedUtilityType: any[] = [];
  //regex = /^[0-9]*$/;
  //regex = /^\d+(\d{1,2})?$/

  regex = /^[1-9]\d*$/;
  //gstregex: RegExp = /^(1?[0-9]|2[0-8])$/;
  gstregex: RegExp = /^(1|[1-9]|[1-2][0-8])$/;

  regex_Alphanumeric = /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/;

  //regex_Alphanumeric = /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)?$/; //Only Alpha numeric are allowed
  NumberWithDecimalregex: RegExp = /^\d+(\.\d+)?$/;
  //Onlynumberwithdecimals = /^(0[1-9]\d*)(\.\d+)?$/;

  // Onlynumberwithdecimals = /^(?:[1-9]\d*|\d\d+(\.\d+)?)$/;
  Onlynumberwithdecimals = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

  public gridData: unknown[] = billData;
  public gridView!: unknown[];

  public gridDataInvoice: unknown[] = invoiceData;
  public gridViewInvoice!: unknown[];

  @ViewChild('dp', { static: true }) datePicker: any;

  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  billGenType?: string;
  allBillSettingList: any[] = [];
  projectUtilities: any;
  constructor(
    private modalService: BsModalService,
    private notificationService: NotificationService,
    private billSettingsService: BillSettingsService,
    private sharedService: SharedService,
    private router: Router,
    private store: Store,
    private loaderService: LoaderService,
    private formBuilder: UntypedFormBuilder,
    private PdfexportService: PdfexportService,
    private BillsService: BillSettingsService,
  ) {
    this.currentdate = new Date();
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    this.projectUtilities = this.currentUserData?.projectUtilities;

    if (this.currentUserData.project !== null) {
      this.projectId = this.currentUserData.project.id;
      this.billingType = this.currentUserData.project.billingType;
      this.billGenType = this.currentUserData.project.billGenerationType;
    }
    this.form = this.formBuilder.group({
      name: [
        '',
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.pattern(this.regex_Alphanumeric),
          Helper.noWhitespaceValidator(),
        ],
      ],
      utilityId: [null], // dropdown
      charges: this.formBuilder.array([]),
    });

    this.breadCrumbItems = [
      {
        label: 'Bill Settings',
      },
    ];
    /*  this.billsChargeForm = this.formBuilder.group({
       name: [
         ,
         [
           Validators.required,
           Validators.pattern(this.regex_Alphanumeric),
           Helper.noWhitespaceValidator(),
         ],
       ],
       amount: [
         '',
         [
           Validators.required,
           Validators.pattern(this.Onlynumberwithdecimals),
           ,
           Validators.max(100000),
         ],
       ],
       utilityType: [,],
       gst: [''],
       GST_Applicable: [false],
       total: [''],
       chargeApplicableDate: [null],
     }); */
    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };

    this.UtlityindividualbillForm = this.formBuilder.group({
      gas_array: this.formBuilder.array([]),
      water_array: this.formBuilder.array([]),
      electricity_array: this.formBuilder.array([]),
      triSource_array: this.formBuilder.array([]),

      PenaltyApplicable_dateOthers: [null, [Validators.required]],
      PenalityAmountForOthers: [
        ,
        [
          Validators.required,
          Validators.pattern(this.Onlynumberwithdecimals),
          Validators.max(100000),
        ],
      ],
    });

    /*   this.invoiceAddForm = this.formBuilder.group({
        slot: ['', [Validators.required]],
        date: ['', [Validators.required]],
        files: ['', [Validators.required]],
      }); */

    this.combinedBillForm = this.formBuilder.group({
      amount: [
        '',
        [
          Validators.required,
          Validators.pattern(this.Onlynumberwithdecimals),
          Validators.max(100000),
        ],
      ],
      date: ['', [Validators.required]],
    });
    this.addRow();
    this.charges.setValidators(this.previousRowValidator());
    this.getAllConfigData();
    this.getBillsStoreInfo();
  }
  get charges(): FormArray {
    return this.form.get('charges') as FormArray;
  }
  createRow(): FormGroup {
    return this.formBuilder.group(
      {
       
        sqftMin: this.formBuilder.control('', [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.max(100000000),
        ]),
        sqftMax: this.formBuilder.control('', [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.max(100000000),
        ]),
        isGSTApplicable: [false],
        chargeApplicableDate: [null],
        amount: this.formBuilder.control('', [
          Validators.required,
          Validators.pattern(this.Onlynumberwithdecimals),
          Validators.max(100000),
        ]),
        gst: this.formBuilder.control(''),
        total: this.formBuilder.control({ value: '', disabled: true }),
      },
      {
        validators: [this.minLessThanMaxValidator()], // ✅ Correct new syntax
      },
    );
  }
  addRow() {
    this.charges.markAllAsTouched();
    this.charges.updateValueAndValidity();

    if (this.charges.invalid) {
      this.sharedService.showMessageDialog(
        'Fix validation errors before adding new row.',
        '',
        SweetAlertIcon.ERROR,
      );
      //  alert('Fix validation errors before adding new row.');
      return;
    }

    this.charges.push(this.createRow());
    this.charges.updateValueAndValidity();
  }

  resetChargeForm(): void {
    this.form.reset({
      name: '',
      utilityId: null,
    });
    this.billChargeId = '';
    this.submitted = false;

    this.charges.clear();
    this.charges.push(this.createRow());
    this.charges.markAsPristine();
    this.charges.markAsUntouched();
    this.charges.updateValueAndValidity();
  }

  removeRow(i: number) {
    this.charges.removeAt(i);
    this.charges.updateValueAndValidity();
  }
  minLessThanMaxValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const min = +group.get('sqftMin')?.value;
      const max = +group.get('sqftMax')?.value;

      if (!min || !max) return null;

      return min >= max ? { minGreaterOrEqualMax: true } : null;
    };
  }
  previousRowValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormArray)) return null;

      const rows = control.controls as FormGroup[];

      // clear old errors
      rows.forEach((row) => {
        const minCtrl = row.get('sqftMin');
        if (minCtrl?.hasError('notSequential')) {
          const errors = { ...minCtrl.errors };
          delete errors['notSequential'];
          minCtrl.setErrors(Object.keys(errors).length ? errors : null);
        }
      });

      for (let i = 1; i < rows.length; i++) {
        const prevMax = +rows[i - 1].get('sqftMax')?.value;
        const currMinCtrl = rows[i].get('sqftMin');
        const currMin = +currMinCtrl?.value;

        if (!prevMax || currMin === null) continue;

        if (currMin !== prevMax) {
          currMinCtrl?.setErrors({
            ...(currMinCtrl.errors || {}),
            notSequential: true,
          });
          return { invalidSequence: true };
        }
      }

      return null;
    };
  }
  add_electricity_Row() {
    let row = this.formBuilder.group({
      PenalityAmountForElectricity: [
        ,
        [Validators.required, Validators.pattern(this.Onlynumberwithdecimals)],
      ],
      PenaltyApplicable_dateElectricity: [
        null,
        [Validators.required, Validators.max(100000)],
      ],
    });
    this.electricity_array.push(row);
  }
  add_triSource_Row() {
    let row = this.formBuilder.group({
      PenalityAmountForTriSources: [
        ,
        [Validators.required, Validators.pattern(this.Onlynumberwithdecimals)],
      ],
      PenaltyApplicable_dateTriSources: [
        null,
        [Validators.required, Validators.max(100000)],
      ],
    });
    this.triSource_array.push(row);
  }
  add_Gas_Row() {
    let row = this.formBuilder.group({
      PenalityAmountForGas: [
        ,
        [Validators.required, Validators.pattern(this.Onlynumberwithdecimals)],
      ],
      penaltyApplicable_dateGas: [
        null,
        [Validators.required, Validators.max(100000)],
      ],
    });
    this.gas_array.push(row);
  }
  add_Water_Row() {
    let row = this.formBuilder.group({
      PenalityAmountForWater: [
        ,
        [Validators.required, Validators.pattern(this.Onlynumberwithdecimals)],
      ],
      PenaltyApplicable_dateWater: [
        null,
        [Validators.required, Validators.max(100000)],
      ],
    });
    this.water_array.push(row);
  }

  get electricity_array(): FormArray {
    return this.UtlityindividualbillForm.get('electricity_array') as FormArray;
  }
  get triSource_array(): FormArray {
    return this.UtlityindividualbillForm.get('triSource_array') as FormArray;
  }
  get water_array(): FormArray {
    return this.UtlityindividualbillForm.get('water_array') as FormArray;
  }
  get gas_array(): FormArray {
    return this.UtlityindividualbillForm.get('gas_array') as FormArray;
  }

  onPenalityApplicableChange(isApplicable: boolean) {
    console.log(isApplicable);
    if (!isApplicable) {
      const controls = this.UtlityindividualbillForm.controls;
      Object.keys(controls).forEach((controlName) => {
        const control = controls[controlName];
        if (control instanceof FormArray) {
          control.clearValidators();
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity();
      });
    }

    /* const individualFields = [
      'PenalityAmountForElectricity',
      'PenalityAmountForOthers',
      'PenalityAmountForGas',
      'PenalityAmountForWater',
      'PenaltyApplicable_dateElectricity',
      'PenaltyApplicable_dateGas',
      'PenaltyApplicable_dateWater',
      'PenaltyApplicable_dateOthers',
    ]; */

    // Toggle validators for individualbillForm fields
    /* individualFields.forEach(field => {
      const control = this.individualbillForm.get(field);
      if (control) {
        if (isApplicable) {
          control.setValidators([Validators.required, Validators.pattern(this.Onlynumberwithdecimals)]);
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity();
      }
    }); */

    // Toggle validators for combinedBillForm fields

    const combinedFields = ['amount', 'date'];
    combinedFields.forEach((field) => {
      const control = this.combinedBillForm.get(field);
      if (control) {
        if (isApplicable) {
          control.setValidators([
            Validators.required,
            Validators.pattern(this.Onlynumberwithdecimals),
          ]);
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity();
      }
    });
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;

    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();

      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }

  getAllConfigData() {
    let payload = ['utilities'];
    this.sharedService.getAllConfigData(payload).subscribe((data) => {
      if (
        data.statusCode == 200 &&
        data.message == 'Config data retrieved successfully.'
      ) {
        this.configData = data.data;
        this.utilityList = this.configData.utilities;
        // Exclude EV utility from dropdowns
        this.filteredUtilityList = this.utilityList.filter((u: any) => {
          const n = (u.name || '').toString().trim().toLowerCase();
          return n !== 'ev';
        });
        console.log('utilityList', this.utilityList.map((u: any) => u.name));
        console.log('filteredUtilityList', this.filteredUtilityList.map((u: any) => u.name));
      }
    });
  }
  /*  get billsControls() {
     return this.billsChargeForm.controls;
   } */
  get combinedBillFormControls() {
    return this.combinedBillForm.controls;
  }
  /*  get invoiceAddFormFormControls() {
     return this.invoiceAddForm.controls;
   } */

  get optionalbillsControls() {
    return this.UtlityindividualbillForm.controls;
  }
  private updateBillChargeResponse$: Subscription = new Subscription();
  private exportSubscription: Subscription = new Subscription();
  getBillsStoreInfo() {
    this.store.dispatch(resetState());
    let getBillSetting$ = this.store.pipe(select(getBillSettingResponse));
    let getInvoiceAds$ = this.store.pipe(select(getBillinvloiceResponse));
    let deleteResponse$ = this.store.pipe(select(deleteBillChargeResponse));
    let createresponse$ = this.store.pipe(select(createBillChargeResponse));
    let updateOptionalBillChargeResponse$ = this.store.pipe(
      select(updateOptionalBillChargeResponse),
    );

    this.updateBillChargeResponse$ = this.store
      .pipe(select(updateBillChargeResponse))
      .subscribe({
        next: (res: any) => {
          if (res) {
            // console.log(res)
            //this.loaderService.setLoading(false);
            this.getbillSettings();
          }
        },
      });

    //

    this.exportSubscription = this.store
      .pipe(select(getAllBillSettingResponse))
      .subscribe((res: any) => {
        if (res) {
          console.log('export data', res);
          this.allBillSettingList = [];
          this.loaderService.setLoading(false);
          if (res.items.length > 0) {
            this.allBillSettingList = [...res.items];
            const transformedData = this.allBillSettingList.map((item: any) => {
              const amount = item?.amount ?? 0;
              const gstPer = item?.gst ?? 0;
              const gstApplicable = !!item?.isGSTApplicable;
              const gstAmount = gstApplicable ? (amount * gstPer) / 100 : '-';
              return {
                'Service Name': item.name,
                Amount: item.amount,
                Utility: item.utility,
                'Created On': formatDate(
                  item.createdOn,
                  'dd MMM yyyy',
                  'en-US',
                ),
                ...(this.billingType !== 'Postpaid' && {
                  'Deduction Date':
                    item.chargeApplicableDate === ''
                      ? '-'
                      : this.formatBillingDate(item.chargeApplicableDate),
                }),
                'GST Applicable': gstApplicable ? 'Yes' : 'No',
                'GST(%)': gstApplicable ? item.gst : '-',
                'GST Amount': gstAmount,
                Total: item.total,
              };
            });

            this.PdfexportService.downloadExcel(
              transformedData,
              'Bills Settingsxlsx',
            );
          } else {
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR,
            );
          }
        }
      });

    let getOptionallist$ = this.store.pipe(select(getOptionalResponse));

    getOptionallist$.subscribe((res: any) => {
      this.loaderService.setLoading(false);
      if (res) {
        this.optionalList = res;
        //console.log(res);
        //console.log(res);
        this.isPenalityApplicable = this.optionalList[0]?.isPenaltyApplicable;
        if (this.billGenType == 'Combined') {
          this.combinedBillForm.patchValue({
            amount: this.optionalList[0]?.penalityAmountForCombined,
            date: this.optionalList[0]?.penaltyApplicable_dateCombined,
          });
        } else {
          this.UtlityindividualbillForm.patchValue({
            PenaltyApplicable_dateOthers:
              this.optionalList[0]?.penaltyApplicable_dateOthers,
            PenalityAmountForOthers:
              this.optionalList[0]?.penalityAmountForOthers,
          });

          this.optionalList.forEach((item: any, index: number) => {
            let dt = this.UtlityindividualbillForm.get(
              'gas_array',
            ) as FormArray;
            dt.at(index).patchValue({
              penaltyApplicable_dateGas: item.penaltyApplicable_dateGas,
              PenalityAmountForGas: item.penalityAmountForGas,
            });
          });
          this.optionalList.forEach((item: any, index: number) => {
            let dt = this.UtlityindividualbillForm.get(
              'electricity_array',
            ) as FormArray;
            dt.at(index).patchValue({
              PenaltyApplicable_dateElectricity:
                item.penaltyApplicable_dateElectricity,
              PenalityAmountForElectricity: item.penalityAmountForElectricity,
            });
          });
          this.optionalList.forEach((item: any, index: number) => {
            let dt = this.UtlityindividualbillForm.get(
              'triSource_array',
            ) as FormArray;
            dt.at(index).patchValue({
              PenaltyApplicable_dateTriSources:
                item?.PenaltyApplicable_dateTriSources,
              PenalityAmountForTriSources: item?.PenalityAmountForTriSources,
            });
          });
          this.optionalList.forEach((item: any, index: number) => {
            let dt = this.UtlityindividualbillForm.get(
              'water_array',
            ) as FormArray;
            dt.at(index).patchValue({
              PenaltyApplicable_dateWater: item.penaltyApplicable_dateWater,
              PenalityAmountForWater: item.penalityAmountForWater,
            });
          });
        }
      }
      // console.log('this.optionalList', res, this.optionalList);
    });

    getBillSetting$.subscribe((res: any) => {
      this.loaderService.setLoading(false);
      if (res) {
        this.billSettingList = [...res.items];
        this.pageSize = res.pageSize;
        this.billstotalUserCount = res.totalCount;
        this.loadBillsGridTable();
      }
      // console.log('billSettingList', res, this.billSettingList);
    });
    getInvoiceAds$.subscribe((res: any) => {
      this.loaderService.setLoading(false);
      if (res) {
        this.billInvoiceList = [...res.items];
        this.pageSize = res.pageSize;
        this.billstotalUserCount = res.totalCount;
        this.loadBillsInvoiceGridTable();
      }
      // console.log('billSettingList', res, this.billInvoiceList);
    });

    deleteResponse$.subscribe((res: any) => {
      if (res) {
        this.getbillSettings();
      }
    });
    createresponse$.subscribe((res: any) => {
      if (res) {
        this.getbillSettings();
      }
    });

    updateOptionalBillChargeResponse$.subscribe((res: any) => {
      if (res) {
        this.store.dispatch(getOptionallist({ projectId: this.projectId }));
      }
    });
  }

  ngOnDestroy() {
    this.updateBillChargeResponse$.unsubscribe();
    this.exportSubscription.unsubscribe(); // Or set it to [] if you prefer an empty array
  }

  loadBillsInvoiceGridTable() {
    const state: any = {
      take: this.pageSize,
      sort: this.sort,
      filter: this.filter,
    };
    const processedData = process(this.billInvoiceList, state);
    this.billInvoicegridData = {
      data: this.billInvoiceList,
      total: this.billsInvoicetotalUserCount,
    };
    // console.log(this.billInvoicegridData);
    this.loaderService.setLoading(false);
  }

  loadBillsGridTable() {
    const state: any = {
      take: this.pageSize,
      sort: this.sort,
      filter: this.filter,
    };
    const processedData = process(this.billSettingList, state);
    this.billSettinggridData = {
      data: this.billSettingList,
      total: this.billstotalUserCount,
    };
    //console.log(this.billSettinggridData);
    this.billSettinggridData.data = this.billSettinggridData?.data.map(
      (bill) => {
        return {
          ...bill,
          gstStatus: bill.isGSTApplicable ? 'Yes' : 'No',
          createdOn: `${Helper.formatDate(bill?.createdOn)}`,
          chargeApplicableDate:
            bill.chargeApplicableDate === ''
              ? ' '
              : this.formatBillingDate(bill.chargeApplicableDate),
        };
      },
    );
    this.loaderService.setLoading(false);
  }
  private files: any[] = [];
  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      // this.file = event.target.files[0]
      var fromdate = new FormData();
      //this.invoiceAddForm.patchValue({ image: this.file });
      // fromdate.append('file', file);

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => {
        // called once readAsDataURL is completed
        this.url = event?.target?.result;
        //  console.log(this.url);
      };
    }
  }
  onFilter(value: any) {
    const inputValue = value;
    this.invoicesearchedValue = value;
    this.store.dispatch(
      getBillinvloicelist1({
        pageIndex: this.invoicecurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.invoicesearchedValue,
      }),
    );
  }
  deleteInvoice() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          swalWithBootstrapButtons.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success',
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error',
          );
        }
      });
  }

  utilityChange(event: any) {
    console.log(event);
  }
  /**
   * Advertisment modal
   * @param addAdvertismentModal Advertisment modal data
   */
  showAdvertismentModal(addAdvertismentModal: any) {
    this.modalRef = this.modalService.show(addAdvertismentModal);
  }

  /**
   * Charge modal
   * @param addChargeModal Advertisment modal data
   */
  showChargeModal(addChargeModal: any) {
    this.modalRef = this.modalService.show(addChargeModal);
  }
  currentUserData: any;
  projectId: any;
  billingType: any;
  ngOnInit(): void {
    this.notificationService.emitNotificationUpdate();
    const utilityRowAdders: { [key: string]: () => void } = {
      Electricity: this.add_electricity_Row.bind(this),
      Gas: this.add_Gas_Row.bind(this),
      Water: this.add_Water_Row.bind(this),
      // 'EV': this.add_EV_Row.bind(this),
      TriSource: this.add_triSource_Row.bind(this),
    };

    this.projectUtilities.forEach((utility: any) => {
      const rowAdder = utilityRowAdders[utility.name]; // Get the corresponding function
      if (rowAdder) {
        rowAdder(); // Call the function to add the row
      } else {
        console.log(`No row-adding function for utility: ${utility.name}`);
      }
    });

    this.gridView = this.gridData;
    // this.billsChargeForm.controls['total'].disable();
    this.gridViewInvoice = this.gridDataInvoice;

    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    if (this.currentUserData.project !== null) {
      this.projectId = this.currentUserData.project.id;
      this.billingType = this.currentUserData.project.billingType;
      this.billGenType = this.currentUserData.project.billGenerationType;
    }

    this.getbillSettings();
    this.getOptionallist();
  }
  public onValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.PageChange({ skip: 0, take: this.pageSize });
      //  this.getUsersData();
    }
    /*  if (ev.length == 0) {
      this.invoicePageChange({ skip: 0, take: this.pageSize });
      this.getbillSettings();
    } */
  }
  private triggerSearch(): void {
    const trimmedValue = this.searchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedValue.length === 0) {
      this.PageChange({ skip: 0, take: this.pageSize });
      this.getbillSettings();
      return;
    }

    // Otherwise — run search
    this.getbillSettings();
  }
  onSearchWalletSettings() {
    this.triggerSearch();
    /* if (this.searchedValue.length > 0) {
      this.getbillSettings();
    } */
  }

  getbillSettings() {
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    if (this.currentUserData.project !== null) {
      this.projectId = this.currentUserData.project.id;
    }
    console.log('this.projectId---->', this.projectId);
    this.store.dispatch(
      getBillSettingslists({
        projectId: this.projectId,
        pageIndex: this.billscurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      }),
    );
  }

  getAllbillSettings() {
    this.store.dispatch(
      getAllBillSettingslists({
        projectId: this.projectId,
        pageIndex: 1,
        pageSize: undefined,
        searchTerm: '',
        filter: '',
        orderBy: '',
      }),
    );
  }
  getInvoiceList() {
    this.store.dispatch(
      getBillinvloicelist1({
        pageIndex: this.invoicecurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.invoicesearchedValue,
        orderBy: this.orderByQuery,
      }),
    );
  }
  getOptionallist() {
    this.store.dispatch(getOptionallist({ projectId: this.projectId }));
  }
  parseApplicableDate(text: string): string {
    console.log('Input Text:', text);
    if (!text) return '';

    text = text.toString().toLowerCase();

    // CASE 1: "X of every month"
    if (text.includes('of every month')) {
      return text.match(/\d+/)?.[0] || '';
    }

    // CASE 2: "X days before calendar"
    if (text.includes('days before calendar')) {
      return text.match(/\d+/)?.[0] || '';
    }

    // CASE 3: "last day" / "last"
    if (text.includes('last')) {
      return 'last day of the month';
    }

    console.log('No matching case found, returning original text.', text);
    // DEFAULT → return original
    return text;
  }

  saveCharge(type: string) {
    this.loaderService.setLoading(true);
    const invalidControls = this.sharedService.findInvalidControls(this.form);
    // console.log(this.billsChargeForm.value)
    console.log('Invalid controls:', invalidControls);
    console.log('Invalid controls:', this.form.value);
    this.submitted = true;
    this.charges.controls.forEach((row: AbstractControl) => {
      const isGstApplicable = row.get('isGSTApplicable')?.value;
      const gstCtrl = row.get('gst');
      if (isGstApplicable) {
        gstCtrl?.setValidators([
          Validators.required,
          Validators.pattern(this.regex),
          Validators.max(28),
        ]);
      } else {
        gstCtrl?.clearValidators();
      }
      gstCtrl?.updateValueAndValidity({ emitEvent: false });
    });
    this.form.updateValueAndValidity({ emitEvent: false });
    if (this.form.invalid) {
      this.loaderService.setLoading(false);
      return;
    } else {
      const rwaData = this.form.getRawValue();
      console.log(rwaData);
      const patterns = ['of every month', 'day before calendar', 'last'];
      //  if isGSTApplicable is null then add false to each charge
      rwaData.charges = rwaData.charges.map((c: any) => ({
        ...c,
        isGSTApplicable: c.isGSTApplicable ?? false,
      }));
      /*  rwaData.charges = rwaData.charges.map((c: any) => {
        return {
          ...c,
          chargeApplicableDate: this.parseApplicableDate(c.chargeApplicableDate)
        };
      }); */

      if (Array.isArray(rwaData.charges)) {
        rwaData.charges = rwaData.charges.map((c: any) => ({
          ...c,
          isGSTApplicable: c.isGSTApplicable ?? false,
          chargeApplicableDate: this.parseApplicableDate(
            c?.chargeApplicableDate,
          ),
        }));
      }
      console.log('Final Output:', rwaData);

      rwaData.projectId = this.projectId;

      /*   let request = {
          id: this.billChargeId != undefined ? this.billChargeId : '',
          name: this.billsChargeForm.get('name')?.value,
          amount: this.billsChargeForm.get('amount')?.value,
          utilityId: this.billsChargeForm.get('utilityType')?.value
            ? this.billsChargeForm.get('utilityType')?.value
            : null,
          isGSTApplicable:
            this.billsChargeForm.get('GST_Applicable')?.value == null
              ? false
              : this.billsChargeForm.get('GST_Applicable')?.value,
          gst:
            this.billsChargeForm.get('gst')?.value == null
              ? ''
              : this.billsChargeForm.get('gst')?.value,
  
          total: '',
          projectId: this.projectId,
           ChargeApplicableDate:
             this.billingType !== 'Postpaid'
               ? result.toString()
               : null,
        }; */
      /*  const amountString = this.billsChargeForm.get('total')?.value;
       const amountNumber = parseFloat(amountString);
       if (!isNaN(amountNumber)) {
         const formattedAmount = amountNumber.toFixed(2);
         //  console.log(formattedAmount);
         request['total'] = formattedAmount;
       } */
      console.log(rwaData);
      if (type == 'Create') {
        this.BillsService.createBillCharge(rwaData).subscribe({
          next: (res: any) => {
            if (res.statusCode == 201) {
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'Success',
                res.message,
                SweetAlertIcon.SUCCESS,
              );
              this.getbillSettings();
            }
          },
          error: (err: any) => {
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              err.error.message,
              '',
              SweetAlertIcon.ERROR,
            );
          },
        });

        // this.store.dispatch(createBillCharge({ billCharge: request }));
      } else {
          this.BillsService.updatetBillCharge(rwaData).subscribe({
          next: (res: any) => {
            if (res.statusCode == 200) {
    this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'Success',
                res.message,
                SweetAlertIcon.SUCCESS
              );
                 this.getbillSettings();
            }
       
            },error: (err: any) => {
                 this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              err.error.message,
              '',
              SweetAlertIcon.ERROR
            );
          }
        })
    
     

        //this.store.dispatch(updateBillCharge({ UpdateBillCharge: request }));
      }
      //this.getbillSettings();
      this.modelRef_1.hide();
      this.resetChargeForm();
    }
  }
  handleFileSelected(event: any) {
    this.files = [];
    const newFiles = event.files.filter(
      (f: any) =>
        !this.files.find((existingFile) => existingFile.name == f.name),
    );
    this.files = [...this.files, ...newFiles];
    //  console.log(this.files);
  }

  handleFileRemoved(event: any) {
    //  console.log(event);
  }
  invoiceId: any;
  /*  saveinvoiceAdd(type: string) {
     this.individualbillSubmitted = true;
     // console.log(this.invoiceAddForm.value);
     if (this.invoiceAddForm.invalid) {
       return;
     } else {
       if (type == 'Create') {
         this.store.dispatch(
           createInvoice({
             Invoice: this.invoiceAddForm.value,
             projectId: this.projectId,
           })
         );
       } else {
         this.store.dispatch(
           updateInvoice({
             UpdateInvoice: this.invoiceAddForm.value,
             id: this.invoiceId,
             projectId: this.projectId,
           })
         );
       }
       getBillinvloicelist1({
         pageIndex: this.invoicecurrentPage,
         pageSize: this.pageSize,
         searchTerm: this.invoicesearchedValue,
         orderBy: this.orderByQuery,
       });
       this.invoiceAdd.hide();
     }
   } */

  saveOptionalfrom() {
    var projectData: any;
    console.log(this.billGenType);
    if (this.billGenType == 'Combined') {
      this.individualbillSubmitted = true;
      if (this.combinedBillForm.invalid) {
        return;
      } else {
        projectData = {
          optional: [
            {
              utility: 'Total',
              date: this.combinedBillForm.get('date')?.value
                ? this.combinedBillForm.get('date')?.value.toString()
                : null, // Default to an empty string if null
              amount: this.combinedBillForm.get('amount')?.value || 0, // Default to an empty string if null
            },
          ],
          projectId: this.projectId,
          IsPenaltyApplicable: this.isPenalityApplicable,
        };
      }
    } else {
      this.optionalSubmitted = true;
      console.log(this.UtlityindividualbillForm.value);
      if (this.UtlityindividualbillForm.invalid) {
        return;
      } else {
        // var projectData = { ...this.UtlityindividualbillForm.getRawValue() };
        /*  const names = this.projectUtilities.map((item: { name: any; }) => item.name);
         projectData = {
           utility: names,
           Charges: { ...this.UtlityindividualbillForm.getRawValue() },
           projectId: this.projectId,
           IsPenaltyApplicable: this.isPenalityApplicable // ensure this is a boolean
 
 
         };
         console.log(this.UtlityindividualbillForm.value) */

        console.log(this.UtlityindividualbillForm.value);
        const names = this.projectUtilities.map(
          (item: { name: string }) => item.name,
        );

        names.push('Others');
        console.log(names);
        // Prepare the request dynamically
        let request = {
          optional: names.map((utility: string) => {
            let dateValue = null;
            let amountValue = 0;

            // Dynamically access the corresponding array for each utility
            if (utility !== 'Others') {
              const utilityData = this.UtlityindividualbillForm.get(
                `${utility.toLowerCase()}_array`,
              )?.value[0]; // Dynamic array lookup

              if (utilityData) {
                dateValue =
                  utilityData[`penaltyApplicable_date${utility}`] ?? null; // Dynamic date property
                amountValue = utilityData[`PenalityAmountFor${utility}`] ?? 0; // Dynamic amount property
              }
            } else {
              // For "Others", handle separately as it's not in the array form
              dateValue =
                this.UtlityindividualbillForm.get(
                  'PenaltyApplicable_dateOthers',
                )?.value ?? null;
              amountValue =
                this.UtlityindividualbillForm.get('PenalityAmountForOthers')
                  ?.value ?? 0;
            }

            return {
              utility: utility, // The name of the utility
              date: dateValue ? dateValue.toString() : null, // Convert to string if necessary
              amount: amountValue, // Default to 0 if value is null
            };
          }),
          projectId: this.projectId,
          IsPenaltyApplicable: this.isPenalityApplicable, // Assuming it's a boolean
        };

        console.log(request);
        projectData = request;
      }
    }

    this.store.dispatch(
      updateOptionalBillCharge({ UpdateOptionalBillCharge: projectData }),
    );
    this.individualbillSubmitted = false;
    // this.store.dispatch(getOptionallist({ projectId: this.projectId }));

    //this.individualbillForm.reset()
    //this.combinedBillForm.reset()
  }

  deletdinvoiceAdd(dataItem: any): void {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.store.dispatch(deleteInvoice({ id: dataItem.id }));
          getBillinvloicelist1({
            pageIndex: this.invoicecurrentPage,
            pageSize: this.pageSize,
            searchTerm: this.invoicesearchedValue,
            orderBy: this.orderByQuery,
          });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error',
          );
        }
      });
  }

  deletdBillCharge(dataItem: any): void {
    console.log(dataItem);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.store.dispatch(deleteBillCharge({ id: dataItem.charges[0].id }));
          this.getbillSettings();
          /*  swalWithBootstrapButtons.fire(
             'Deleted!',
             'Your file has been deleted.',
             'success'
           ); */
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error',
          );
        }
      });
  }

  billChargeId: any;
  loadBillChargeForEdit(apiItem: any) {
    // 1. Main fields
    this.form.patchValue({
      name: apiItem.name,
      utilityId: apiItem.utilityId ?? null,
    });
   

    // 2. Fill FormArray
    const ratesFA = this.form.get('charges') as FormArray;
    ratesFA.clear();
    //const date = apiItem.chargeApplicableDate?.trim();
    apiItem.charges.forEach((ch: any) => {
      const row = this.createRow();
      row.patchValue({
        sqftMin: ch.sqftMin,
        sqftMax: ch.sqftMax,
        amount: ch.amount,
        chargeApplicableDate: ch.chargeApplicableDate,
        isGSTApplicable: ch.isGSTApplicable,
        gst: ch.gst,
        total: ch.total,
      });

      ratesFA.push(row);
    });

    // 3. Run validations
    ratesFA.updateValueAndValidity();
  }

  editBillCharge(data: any, addChargeModal: any) {
    this.billChargeId = data.id;
    console.log(data);
    this.loadBillChargeForEdit(data);
    this.modelRef_1 = this.modalService.show(addChargeModal, {
      class: 'modal-dialog-centered custom-charge-modal',
      backdrop: 'static',
    });
  }

  exportAll() {
    this.loaderService.setLoading(true);
    this.BillsService.getBillsSetingUrl(
      1,
      undefined,
      '',
      this.projectId,
      '',
      '',
    ).subscribe({
      next: (res: any) => {
        if (res.statusCode == 200) {
          this.billselectedRowdata = [];
          console.log('export url', res);
          this.billsSettingsExport(res.data.items, 'All');
        } else {
          this.loaderService.setLoading(false);
          this.sharedService.showMessageDialog(
            'No data to display',
            '',
            SweetAlertIcon.ERROR,
          );
        }
      },
      error: (err: any) => {
        this.loaderService.setLoading(false);
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR,
        );
        /*  this.sharedService.showMessageDialog(
           err.error.message,
           '',
           SweetAlertIcon.ERROR
         ); */
      },
    });
  }
  billsSettingsExport(dataItems: any, type: string): void {
    let data: any;
    if (type == 'All') {
      data = dataItems;
    } else {
      data =
        this.billselectedRowdata.length > 0
          ? this.billselectedRowdata
          : this.billSettinggridData.data;
    }

    const workbook = XLSX.utils.book_new();
    const masterDetailData: any[] = [];
    if (data.length > 0) {
      data.forEach((item: any) => {
        masterDetailData.push({
          Name: item.name,
          Utility: item.utilityName,
          'Sq Ft min': item.closingBalance,
          'Sq Ft Max': '',
          Amount: '',
          'Created On': '',
          'GST Applicable': '',
          'GST(%)': '',
          'GST Amount': '',
          'Deducation Date': '',
          Total: '',
        });

        item.charges.forEach((detail: any) => {
          const amount = detail?.amount ?? 0;
            const gstPer = detail?.gst ?? 0;
            const gstApplicable = !!detail?.isGSTApplicable;
            const gstAmount = gstApplicable ? (amount * gstPer) / 100 : '-';
            masterDetailData.push({
              Name: '',
              Utility: '',
              'Sq Ft min': detail.sqftMin,
              'Sq Ft Max': detail.sqftMax,
              Amount: detail.amount,
              'Created On': formatDate(detail.createdOn, 'dd MMM yyyy', 'en-US'),
              'Deducation Date': this.formatBillingDate(
                detail.chargeApplicableDate,
              ),
              'GST Applicable': gstApplicable ? 'Yes' : 'No',
              'GST(%)': gstApplicable ? detail.gst : '-',
              'GST Amount': gstAmount,
              Total: detail.total,
            });
        });
      });
      console.log('masterDetailData--------->', masterDetailData);
      const worksheet = XLSX.utils.json_to_sheet(masterDetailData, {});

      const range = XLSX.utils.decode_range(worksheet['!ref'] as string);
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: col })];
        if (cell) {
          cell.s = { font: { bold: true } };
        }
      }

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Bills Settings');
      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      saveAs(
        new Blob([wbout], { type: 'application/octet-stream' }),
        'Bills Settings.xlsx',
      );
      this.loaderService.setLoading(false);
    } else {
      this.sharedService.showMessageDialog(
        'No data to display',
        '',
        SweetAlertIcon.ERROR,
      );
    }
  }

  public onExport(type: string) {
    if (type === 'Excel') {
      if (this.billSettinggridData.data.length > 0) {
        setTimeout(() => {
          this.hiddenGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR,
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.hiddenGrid?.saveAsPDF();
      }, 1000);
    }
    /*  if (this.billselectedRowdata.length == 0) {
       this.getAllbillSettings();
     } else {
       if (type === 'Excel') {
         setTimeout(() => {
           this.hiddenGrid?.saveAsExcel();
         }, 1000);
       } else if (type === 'Pdf') {
         setTimeout(() => {
           this.hiddenGrid?.saveAsPDF();
         }, 1000);
       }
     } */
  }

  billsonSelectforBillSetting(event: any) {
    // console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.billselectedRowdata.push(element.dataItem);
        //  console.log(' selected Values : ', this.billselectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.billsdeselectedRowdata.push(element.dataItem);
        //  console.log('deselectedRowdata Values : ', this.billsdeselectedRowdata);
      });

      if (this.billsdeselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.billsdeselectedRowdata.map((item: { id: any }) => item.id),
        );

        const filteredArray = this.billselectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id),
        );
        console.log('', filteredArray);
        this.billselectedRowdata = filteredArray;
      }
    }
  }

  invoiceselectedRowdata: any = [];
  invoicedeselectedRowdata: any = [];
  invoiceSelectforBillSetting(event: any) {
    console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.invoiceselectedRowdata.push(element.dataItem);
        //  console.log(' selected Values : ', this.invoicedeselectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.invoicedeselectedRowdata.push(element.dataItem);
        console.log(
          'deselectedRowdata Values : ',
          this.invoicedeselectedRowdata,
        );
      });

      if (this.invoicedeselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.invoicedeselectedRowdata.map((item: { id: any }) => item.id),
        );

        const filteredArray = this.invoicedeselectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id),
        );
        // console.log('', filteredArray);
        this.invoicedeselectedRowdata = filteredArray;
      }
    }
  }
  deductionDate(event: any) {
    console.log(event);
  }
  invoicecurrentPage: number = 1;
  protected invoicePageChange({ skip, take }: PageChangeEvent): void {
    //  console.log('>>>', skip, take);
    this.skip = skip;
    this.pageSize = take;
    this.invoicecurrentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);
    getBillinvloicelist1({
      pageIndex: this.invoicecurrentPage,
      pageSize: this.pageSize,
      searchTerm: this.invoicesearchedValue,
      orderBy: this.orderByQuery,
    });
    this.loadBillsInvoiceGridTable();
  }

  billscurrentPage: number = 1;
  protected PageChange({ skip, take }: PageChangeEvent): void {
    /// console.log('>>>', skip, take);
    this.billselectedRowdata = [];
    this.skip = skip;
    this.pageSize = take;
    this.billscurrentPage = Math.floor(skip / take) + 1;
    //  console.log('currentpage', Math.floor(skip / take) + 1);
    this.getbillSettings();
    this.loadBillsGridTable();
  }

  protected billStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.pageSize = state.take;
    this.filter = state.filter || { logic: 'and', filters: [] };

    this.loadBillsGridTable();
  }
  protected invoicetateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadBillsInvoiceGridTable();
  }

  public bilsonFilter(value: any): void {
    this.triggerSearch();
    /*  this.invoicePageChange({ skip: 0, take: this.pageSize });
     this.getbillSettings(); */
  }
  /*  onCheckboxChange(event: any) {
     //console.log(event.target.checked);
     if (event.target.checked == true) {
       this.billsChargeForm.controls['gst'].setValue('');
       this.billsControls['gst'].setValidators([
         Validators.required,
         Validators.pattern(this.regex),
         Validators.max(28),
       ]);
       this.billsControls['gst'].updateValueAndValidity();
     } else {
       this.billsChargeForm.controls['gst'].setValue('');
       this.billsControls['gst'].clearValidators();
       this.billsControls['gst'].updateValueAndValidity();
       let amount = this.billsChargeForm.get('amount')?.value;
       this.billsChargeForm.controls['total'].setValue(amount);
     }
   } */
  onCheckboxChange_new(event: any, row: AbstractControl) {
    const checked = event.target.checked;

    const gstCtrl = row.get('gst');
    const amount = row.get('amount')?.value;

    if (checked) {
      // ✅ Enable GST validation
      gstCtrl?.setValue('');
      gstCtrl?.setValidators([
        Validators.required,
        Validators.pattern(this.regex), // your decimal regex
        Validators.max(28),
      ]);
      gstCtrl?.updateValueAndValidity();
    } else {
      // ✅ Remove GST validation
      gstCtrl?.clearValidators();
      gstCtrl?.setValue('');
      gstCtrl?.updateValueAndValidity();

      // ✅ When unchecked → total = amount
      row.get('total')?.setValue(amount);
    }
  }
  calculateRowTotal(row: AbstractControl) {
    console.log('Calculating total for row:', row.value);
    const amount = Number(row.get('amount')?.value) || 0;
    const gst = Number(row.get('gst')?.value) || 0;
    const isGstApplicable = row.get('isGSTApplicable')?.value;

    let total = amount;

    if (isGstApplicable && gst > 0) {
      total = amount + (amount * gst) / 100;
    }

    row.get('total')?.setValue(total.toFixed(2), { emitEvent: false });
  }

  /*  onFocusOutAmount(event: any) {
     let totalamount: number;
     let gstAmount: number;
 
     // Get the GST value from the form and parse it as a float
     let dt = this.billsChargeForm.get('gst')?.value;
     const gstValue = parseFloat(dt);
 
     // Get the amount value from the form and parse it as a float
     const amountValue = parseFloat(this.billsChargeForm.get('amount')?.value);
 
     // Check if the amount and gst are valid numbers
     if (!isNaN(amountValue) && !isNaN(gstValue) && gstValue >= 0) {
       // Perform calculation if both values are valid
       gstAmount = (gstValue * amountValue) / 100;
       totalamount = amountValue + gstAmount;
 
       // Set the calculated total amount
       this.billsChargeForm.controls['total'].setValue(totalamount);
     } else {
       // If GST or amount is invalid, just set the total to the amount value
       this.billsChargeForm.controls['total'].setValue(amountValue || 0);
     }
   } */
  onFocusOutAmount_new(event: any, row: AbstractControl) {
    let totalAmount = 0;
    let gstAmount = 0;

    const gstValue = parseFloat(row.get('gst')?.value || 0);
    const amountValue = parseFloat(row.get('amount')?.value || 0);
    const isGSTApplicable = row.get('isGSTApplicable')?.value;

    if (isGSTApplicable && !isNaN(amountValue) && !isNaN(gstValue)) {
      gstAmount = (gstValue * amountValue) / 100;
      totalAmount = amountValue + gstAmount;
    } else {
      totalAmount = amountValue;
    }

    row.get('total')?.setValue(totalAmount.toFixed(2));
  }
  /* onFocusOut(event: any) {
    const gstValue = parseFloat(event.target.value);
    const amountValue = parseFloat(this.billsChargeForm.get('amount')?.value);
    // const amountValue = this.billsChargeForm.get('amount')?.value;

    if (!isNaN(amountValue) && !isNaN(gstValue) && gstValue >= 0) {
      let totalAmount: number;
      let gstAmount: number;

      gstAmount = (gstValue * amountValue) / 100;
      totalAmount = amountValue + gstAmount;

      this.billsChargeForm.controls['total'].setValue(totalAmount);
    } else {
      // If either GST or amount is invalid, just set total to the amount value
      this.billsChargeForm.controls['total'].setValue(amountValue || 0);
    }
  } */

  /*  openChargeModel(addChargeModal: any) {
     this.billsChargeForm.reset();
     this.billChargeId = '';
     this.submitted = false;
 
     this.modelRef_1 = this.modalService.show(addChargeModal, {
       class: 'modal-dialog-centered',
       backdrop: 'static',
     });
   } */
  openChargeModel(addChargeModal: any) {
    this.resetChargeForm();

    this.modelRef_1 = this.modalService.show(addChargeModal, {
      class: 'modal-dialog-centered custom-charge-modal',
      backdrop: 'static',
    });
  }

  closeChargeModal(): void {
    this.modelRef_1?.hide();
    this.resetChargeForm();
  }
  /*  opemInvoiceModel(addInvoiceModal: any) {
     this.invoiceId = '';
     this.invoiceAddForm.reset();
     this.invoiceAdd = this.modalService.show(addInvoiceModal, {
       class: 'modal-dialog-centered',
     });
   } */
  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];
  async onbillsFilterChange(filter: CompositeFilterDescriptor) {
    this.billsSettings.filter = filter;
    this.skip = 0;
    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customFilterState = _.cloneDeep(this.billsSettings);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.billsSettings,
    );
    console.log('temp-------------->', filterOperators);
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        console.log('gasQueryString', this.customDateFiltersQueryEq);
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          console.log('gasQueryString', this.customDateFiltersQueryNEQ);
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ,
        );
      this.queryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString,
      );
    } else {
      this.queryString = this.sharedService.createQuery(this.customFilterState);
    }

    const queryString = this.sharedService.createQuery(this.billsSettings);
    // this.queryString = this.sharedService.createQuery(this.billsSettings);
    this.billscurrentPage = 1;
    this.getbillSettings();
    // console.log(queryString);
  }

  onbillsSortChange(sort: SortDescriptor[]): void {
    this.billsSettings.sort = sort;
    // console.log(this.billsSettings.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.billsSettings.sort,
    );
    this.orderByQuery = orderByQuery;

    this.getbillSettings();
  }

  /*   public onInvoiceFilterChange(filter: CompositeFilterDescriptor): void {
      this.billsInvoice.filter = filter;
      // console.log(this.billsInvoice);
      const queryString = this.sharedService.createQuery(this.billsInvoice);
      this.queryString = this.sharedService.createQuery(this.billsInvoice);
      this.store.dispatch(
        getBillinvloicelist1({
          pageIndex: this.invoicecurrentPage,
          pageSize: this.pageSize,
          searchTerm: this.invoicesearchedValue,
          orderBy: this.orderByQuery,
        })
      );
      //  console.log(queryString);
    } */
  /*   onInvoicdSortChange(sort: SortDescriptor[]): void {
      this.billsInvoice.sort = sort;
      console.log(this.billsInvoice.sort);
      const orderByQuery = this.sharedService.createOrderByQuery(
        this.billsInvoice.sort
      );
      this.orderByQuery = orderByQuery;
  
      this.getbillSettings();
    } */

  preventManualInput(event: KeyboardEvent): void {
    // Prevent all keys except Tab and Arrow keys, which are essential for navigating
    const allowedKeys = [
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault(); // Prevent input
    }
  }

  formatBillingDate = (date: any): string => {
    if (date && typeof date === 'string') {
      console.log(date);
      return this.getOrdinalSuffix(date);
    }

    return date;
  };

  getOrdinalSuffix = (day: any): string => {
    // Check if day contains "of every month", don't append again
    if (
      day === '2 days before calendar' ||
      day === '1 day before calendar' ||
      day === 'last day of the month'
    ) {
      return day;
    }

    // If day already has 'of every month' appended, don't add it again
    if (day.includes('of every month')) {
      return day;
    }

    const numericDay = day.replace(/(st|nd|rd|th)$/, '');

    // Add ordinal suffix for day
    if (numericDay === '1' || numericDay === '21' || numericDay === '31') {
      return `${numericDay}st of every month`;
    } else if (numericDay === '2' || numericDay === '22') {
      return `${numericDay}nd of every month`;
    } else if (numericDay === '3' || numericDay === '23') {
      return `${numericDay}rd of every month`;
    } else {
      console.log(numericDay);
      return `${numericDay}th of every month`; // Default case
    }
  };
}
